import PackageIndex from '@/views/layanan/paket/PackageIndex.vue';

const packages = [
    {
        path: '/packages',
        name: 'package',
        component: PackageIndex
    }
]

export default packages